// TODO temp, will be updated from the server
export enum ObjectStatus {
  New = 'new',
}
